import { ReactComponent as CheckIcon } from '../../../../images/icon_check_success.svg';
import { IconWrapper, Texts, Title, Wrapper } from './styled';

export default function SuccessStep() {
  return (
    <Wrapper>
      <IconWrapper>
        <CheckIcon />
      </IconWrapper>
      <Texts>
        <Title>Pronto! Você acessou sua conta.</Title>
      </Texts>
    </Wrapper>
  );
}
